import type { JSX, ReactNode } from 'react';

import { useTelefon } from './telefon';

/**
 * PLANEN UND VERWALTEN AB TABLET (Auftrag CRM-106, ÄA-63).
 *
 * Auf dem Telefon ist eine Maske, die so umschlossen ist, nur zum Lesen da:
 * Ein Hinweis steht oben, die Knöpfe der Handlungen (`.knopf`) sind
 * ausgeblendet, Felder nehmen keine Eingabe an (stil.css, `.ab-tablet`).
 * Reiter, Verweise und rollende Tabellen bleiben bedienbar. Ein Knopf, der
 * nur liest oder blättert, trägt `data-auch-telefon` und bleibt stehen.
 *
 * Reine Darstellung: Die Rechte bleiben, wie sie sind, und der Server
 * entscheidet weiter. Über 600 px gibt die Hülle ihren Inhalt unverändert
 * zurück — Desktop und Tablet sehen keinen Unterschied.
 */
export function AbTablet({
  an = true,
  teil = false,
  children,
}: {
  /** Ohne `an` gibt die Hülle ihren Inhalt auch auf dem Telefon unverändert zurück. */
  readonly an?: boolean;
  /**
   * Nur ein Teil der Maske ist ab Tablet (etwa die Positionen einer Akte):
   * Die Handlungen im Seitenkopf bleiben dann stehen.
   */
  readonly teil?: boolean;
  readonly children: ReactNode;
}): JSX.Element {
  const telefon = useTelefon();
  if (!telefon || !an) return <>{children}</>;
  return (
    <div className={teil ? 'ab-tablet ab-tablet--teil' : 'ab-tablet'}>
      <Hinweis />
      {children}
    </div>
  );
}

/**
 * Nur der Hinweis, ohne Hülle — für Masken, die das Bearbeiten selbst
 * abschalten und einfache Handgriffe (etwa einen Storno) stehen lassen.
 */
export function AbTabletHinweis({ an = true }: { readonly an?: boolean }): JSX.Element | null {
  const telefon = useTelefon();
  return telefon && an ? <Hinweis /> : null;
}

function Hinweis(): JSX.Element {
  return (
    <p className="hinweiszeile ab-tablet__hinweis" role="note">
      Bearbeiten ab Tablet — auf dem Telefon nur lesen.
    </p>
  );
}
